import React, { useEffect } from "react";
import { Button, Drawer, Form, Input, Select, Space } from "antd";

const PARTNER_TYPE_OPTIONS = [
  { value: "USER", label: "User" },
  { value: "ORGANIZATION", label: "Organization" },
];

export default function BusinessGrowthPartnerDrawer({
  open,
  editing,
  onClose,
  onSubmit,
  submitting,
}) {
  const [form] = Form.useForm();
  const isEdit = Boolean(editing?.id);

  useEffect(() => {
    if (open) {
      if (editing?.id) {
        form.setFieldsValue({
          displayName: editing.displayName || "",
          email: editing.email || "",
          partnerType: editing.partnerType || undefined,
          userId: editing.userId || undefined,
          businessEntityId: editing.businessEntityId || undefined,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, editing, form]);

  const handleFinish = (values) => {
    const payload = {
      ...values,
      userId: values.userId || null,
      businessEntityId: values.businessEntityId || null,
    };
    onSubmit(payload);
  };

  return (
    <Drawer
      title={isEdit ? "Edit Growth Partner" : "Create Growth Partner"}
      open={open}
      onClose={onClose}
      width={480}
      push={false}
      zIndex={1050}
      footer={
        <Space style={{ float: "right" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={submitting} onClick={() => form.submit()}>
            {isEdit ? "Update" : "Create"}
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="displayName"
          label="Display Name"
          rules={[{ required: true, message: "Display name is required" }]}
        >
          <Input placeholder="Enter display name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[{ type: "email", message: "Enter a valid email" }]}
        >
          <Input placeholder="partner@example.com" />
        </Form.Item>

        <Form.Item
          name="partnerType"
          label="Partner Type"
          rules={[{ required: true, message: "Select a partner type" }]}
        >
          <Select options={PARTNER_TYPE_OPTIONS} placeholder="Select type" />
        </Form.Item>

        <Form.Item
          name="userId"
          label="User ID"
          tooltip="Optional: link to a specific user"
        >
          <Input placeholder="UUID of the user" />
        </Form.Item>

        <Form.Item
          name="businessEntityId"
          label="Business Entity ID"
          tooltip="Optional: link to a specific business entity"
        >
          <Input placeholder="UUID of the business entity" />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
